export default "__VITE_ASSET__BQmHh6YF__"